import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-demo-claims-intimation',
  templateUrl: './demo-claims-intimation.component.html',
  styleUrls: ['./demo-claims-intimation.component.scss']
})
export class DemoClaimsIntimationComponent implements OnInit {

  constructor(
      private router: Router,
  ) { }
  ngOnInit() {
  }

  /* Fake Dataset */
  dataSet = [ {},{} ];
  
  /* Navigate to new Intimation */
  newIntimation() {
    this.router.navigate(['/app/claims/details/intimation/claims-health'], { queryParams: { }, replaceUrl: false } );
  }

}
